import React, { useEffect, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import {
  addEditAdminWalletAddress,
  addEditWalletAddress,
  getAdminWalletAddress,
  getWalletAddress,
} from "../../../../redux/admin/action";
import { styled } from "@mui/material/styles";
import { ethers } from "ethers";

const Item = styled(Index.Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const WalletSetup = () => {
  const navigate = PagesIndex.useNavigate();
  const [walletData, setWalletData] = useState("");
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const { adminToken } = PagesIndex.useSelector((state) => state.AdminReducer);
  const [balance, setBalance] = useState(0);

  let initialValues = {};
  if (walletData) {
    initialValues = {
      id: walletData ? walletData?.id : "",
      privateKey: walletData?.decryptedString
        ? walletData?.decryptedString
        : "",
      walletAddress: walletData?.walletAddress ? walletData?.walletAddress : "",
    };
  } else {
    initialValues = {
      privateKey: walletData?.decryptedString
        ? walletData?.decryptedString
        : "",
      walletAddress: walletData?.walletAddress ? walletData?.walletAddress : "",
    };
  }

  useEffect(() => {
    getAdminWalletAddress(adminToken, navigate).then((res) => {
      setWalletData(res);
    });
  }, []);

  const handleSubmit = (values) => {
    setLoadingUpdate(true);
    addEditAdminWalletAddress(values, adminToken);
    setTimeout(() => {
      setLoadingUpdate(false);
    }, 2000);
  };

  const ERC20_ABI = [
    "function balanceOf(address owner) view returns (uint256)",
    "function decimals() view returns (uint8)",
  ];

  async function checkBalance() {
    try {
      const provider = new ethers.providers.JsonRpcProvider(
        "https://polygon-mainnet.infura.io/v3/8b0543368f884ce190581fe3945060dd"
      );
      const contract = new ethers.Contract(
        "0x911E641E0e576F358b8b62578E8d7ce48979d173",
        ERC20_ABI,
        provider
      );
      const rawBalance = await contract.balanceOf(walletData?.walletAddress);
      const decimals = await contract.decimals();
      const balance = ethers.utils.formatUnits(rawBalance, decimals);
      console.log(`Balance: ${balance}`);
      setBalance(balance);
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  }
  useEffect(() => {
    if (walletData) {
      checkBalance();
    }
  }, [walletData]);

  return (
    <>
      {/* {walletData && ( */}
      <Index.Box className="episap-common-box">
        <Index.Box className="h-100">
          <Index.Box className="card-center">
            <Index.Box className="card-main profile-card-main p-0 w-100">
              <Index.Box className="title-main mb-15 text-center">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="page-title"
                >
                  Admin Wallet Setup
                </Index.Typography>
              </Index.Box>
              <PagesIndex.Formik
                enableReinitialize
                onSubmit={handleSubmit}
                initialValues={initialValues}
                validationSchema={PagesIndex.AdminWalletAddressSchema}
              >
                {({
                  values,
                  errors,
                  touched,
                  setFieldValue,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <form
                    spacing={2}
                    noValidate
                    autoComplete="off"
                    onSubmit={handleSubmit}
                  >
                    <Index.Box className="profile-inner">
                      <Index.Box className="">
                        <Index.Grid
                          container
                          columnSpacing={{ xs: 3.75, sm: 3.75, md: 3.75 }}
                        >
                          <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                            <Index.Box className="sap-token-box">
                              <Index.Typography className="sap-token-item">
                                SAP Token :{" "}
                                <span>
                                  {Number(balance)
                                    ?.toFixed(4)
                                    ?.replace(/\.?0+$/, "")}
                                </span>
                              </Index.Typography>
                            </Index.Box>
                          </Index.Grid>

                          <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                            <Item className="dashboard-item">
                              <Index.Box>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="change-input-label"
                                >
                                  Wallet Address
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border mb-15">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    placeholder=""
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    name="walletAddress"
                                    onBlur={handleBlur}
                                    value={values.walletAddress}
                                    inputProps={{ maxLength: 164 }}
                                    onChange={handleChange}
                                    helperText={
                                      touched.walletAddress &&
                                      errors.walletAddress
                                    }
                                    error={Boolean(
                                      errors.walletAddress &&
                                        touched.walletAddress
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                              <Index.Box>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="change-input-label"
                                >
                                  Wallet Address Secret Key
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border mb-15">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    placeholder=""
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    name="privateKey"
                                    onBlur={handleBlur}
                                    value={values.privateKey}
                                    inputProps={{ maxLength: 164 }}
                                    onChange={handleChange}
                                    type={"password"}
                                    helperText={
                                      touched.privateKey && errors.privateKey
                                    }
                                    error={Boolean(
                                      errors.privateKey && touched.privateKey
                                    )}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Item>
                          </Index.Grid>
                        </Index.Grid>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box mt={5} className="editor-btn text-center">
                      <Index.Button
                        className="editor-submit-btn login-disable"
                        type="submit"
                        data-testid="button"
                        variant="contained"
                        disabled={loadingUpdate}
                      >
                        <img
                          alt="save"
                          src={PagesIndex.Png.invoice}
                          className=""
                        />
                        Update
                      </Index.Button>
                    </Index.Box>
                  </form>
                )}
              </PagesIndex.Formik>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
      {/* )} */}
    </>
  );
};

export default WalletSetup;
